var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2FeacherIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 12.5px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 104.5,
    cy: 142.5,
    r: 32.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_copy",
    "data-name": "Ellipse 2 copy",
    className: "cls-2",
    d: "M194,237a9,9,0,1,1-9,9A9,9,0,0,1,194,237Zm222-50a9,9,0,1,1-9,9A9,9,0,0,1,416,187Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194,237a9,9,0,1,1-9,9A9,9,0,0,1,194,237Zm0,0a9,9,0,1,1-9,9A9,9,0,0,1,194,237Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45,431H448"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75,431V246"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144,429V210H244s27-3.52,27-35H105s-63,7.531-63,61v70s3.129,26,28,26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110,430l-1-104"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232,303l26-23,18,20,53-55,18,20,44-44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193,176V125s-3.8-14,14-14H435s18,2.576,18,19V324s-2.048,21-19,21H209s-17-.059-17-20V275"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277,108s41.531-90.612,93-1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    className: "cls-3",
    d: "M302,346l-26,85Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-3",
    d: "M349,346l29,83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2FeacherIcon);
export default __webpack_public_path__ + "static/media/2-feacherIcon.24255232484e20d8de02e89f3e3e2010.svg";
export { ForwardRef as ReactComponent };